import { API_BASE_URL, COMPANY_PID } from '../config/api';

async function post(path, body) {
  const res = await fetch(`${API_BASE_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok || !data || data.status === false) {
    throw new Error(data?.error || data?.msg || data?.message || `Request failed (${res.status})`);
  }
  return data;
}

// Normalizes one language row from the API into { code, name, nativeName }.
const normalizeLanguage = (row) => ({
  code: row.language_code,
  name: row.language_name,
  nativeName: row.language_translate,
});

// Response shape: { status, translations: { language_code, translations_labels:
// { data: { agency: { <label_key>: { label_value, label_id } }, ...other modules } } } }.
// Only the `agency` module is used by this site, so only that is stored.
const normalizeTranslations = (payload) => {
  const inner = payload?.translations ?? payload;
  const agency = inner?.translations_labels?.data?.agency;
  return agency && typeof agency === 'object' ? { agency } : {};
};

// StrictMode's dev-only double effect (and overlapping callers) would fire
// the same request twice — share whatever is already in flight per key.
const inFlight = new Map();
const dedupe = (key, run) => {
  if (!inFlight.has(key)) {
    inFlight.set(key, run().finally(() => inFlight.delete(key)));
  }
  return inFlight.get(key);
};

// Available languages for the company.
export function getLanguages() {
  return dedupe('languages', async () => {
    const data = await post('/api/company/get-language', { companyKey: COMPANY_PID });
    return (data?.list ?? []).map(normalizeLanguage);
  });
}

// All translated labels for one language: { agency: { key: { label_value } } }.
export function getLabelTranslations(languageCode) {
  return dedupe(`labels:${languageCode}`, async () => {
    const data = await post('/api/auth/get_label_translations', {
      company_pid: COMPANY_PID,
      language_code: languageCode,
    });
    return normalizeTranslations(data);
  });
}
